import { arrayRequired, labeled } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    commissionSplits: arrayRequired(Joi, Joi.object())
      .min(1)
      .label(labeled(label, 'Commission split -'))
  });

export default {
  schema
};
